import { PropsWithChildren } from 'react'
import { useUpdateProgressBar } from '@vivaldis/web-ui'
import { useQuery } from './QueryProvider'

export const ProgressBarProvider = ({
  children
}: PropsWithChildren<unknown>) => {
  const { data, loading } = useQuery()

  useUpdateProgressBar(loading && !data)

  return <>{children}</>
}
